<template>
  <v-layout>
    <v-flex xs12>
      <become-provider-stepper />
    </v-flex>
  </v-layout>
</template>

<script>
import BecomeProviderStepper from "@/components/providers/BecomeProviderStepper";
export default {
  name: "ProviderOnBoarding",
  components: {BecomeProviderStepper}
}
</script>

<style scoped>

</style>